module.exports = __webpack_public_path__ + "img/structures2.22e241ea.svg";